export { fetchEventSource, EventStreamContentType } from './fetch';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@microsoft/fetch-event-source/lib/esm/index.js
// module id = null
// module chunks = 